<script>
import { ref } from 'vue'
import { Navigation } from 'swiper/modules'

export default {
  setup(props, { slots }) {
    const swipers      = ref(false)
    const setTheSwiper = (swiper) => swipers.value = swiper

    return () => slots.default({
      modules: [Navigation],
      setTheSwiper
    })
  }
}
</script>